module.exports = __webpack_public_path__ + "static/media/tour-knifes.bd5bb0aa.svg";